import { JmsdfUnitInfo } from "./JmsdfUnitInfo";

/**
 * 依頼者情報の種類
 */
export const RequesterInfoType = {
    /**
     * 海上自衛隊
     */
    MaritimeRequesterInfo: "MaritimeRequesterInfo",
    /**
     * BtoB
     */
    BusinessRequesterInfo: "BusinessRequesterInfo",
    /**
     * BtoC
     */
    CustomerRequesterInfo: "CustomerRequesterInfo",
} as const;
export type RequesterInfoType = typeof RequesterInfoType[keyof typeof RequesterInfoType];

export interface BaseRequesterInfo {
    type: RequesterInfoType;
};

export interface MaritimeRequesterInfo extends BaseRequesterInfo {
    supplyHeadquartersInfo: JmsdfUnitInfo;
    supplySourceUnitInfo: JmsdfUnitInfo;
};

export interface CivilRequesterInfo extends BaseRequesterInfo {
    /**
     * メンバータイプがguestの場合空文字
     */
    id: string,

    /**
     * 名前
     */
    firstname: string,

    /**
     * 苗字
     */
    lastname: string,

    /**
     * 県
     */
    prefecture: string,
    /**
     * 市住所
     */
    city: string,

    /**
     * 市以降の住所
     */
    address: string,

    /**
     * 郵便番号
     */
    zipcode: string,

    /**
     * 電話番号
     * （電話番号またはメールアドレスは必須）
     */
    tel?: string,
    /**
     * メールアドレス
     * （電話番号またはメールアドレスは必須）
     */
    mailaddress?: string
};

export interface BusinessRequesterInfo extends CivilRequesterInfo {
    companyName: string;
    departmentName?: string;
};

export interface CustomerRequesterInfo extends CivilRequesterInfo {
};

/**
 * 海上自衛隊の依頼者情報のデフォルト値を作成する
 */
export function createDefaultMaritimeRequesterInfo(): MaritimeRequesterInfo {
    return {
        type: RequesterInfoType.MaritimeRequesterInfo,
        supplyHeadquartersInfo: {
            unitName: "",
            lastname: "",
            firstname: "",
            mailaddress: "",
            tel: "",
        },
        supplySourceUnitInfo: {
            unitName: "",
            lastname: "",
            firstname: "",
            mailaddress: "",
            tel: "",
        },
    };
};

/**
 * BtoBの配送先情報のデフォルト値を作成する
 * @returns 
 */
export function createDefaultBusinessRequesterInfo(): BusinessRequesterInfo {
    return {
        type: RequesterInfoType.BusinessRequesterInfo,
        id: "",
        firstname: "",
        lastname: "",
        prefecture: "",
        city: "",
        address: "",
        zipcode: "",
        tel: "",
        companyName: "",
        departmentName: ""
    };
};

/**
 * BtoCの配送先情報のデフォルト値を作成する
 * @returns 
 */
export function createDefaultCustomerRequesterInfo(): CustomerRequesterInfo {
    return {
        type: RequesterInfoType.CustomerRequesterInfo,
        id: "",
        firstname: "",
        lastname: "",
        prefecture: "",
        city: "",
        address: "",
        zipcode: "",
        tel: "",
        mailaddress: ""
    };
};